import { render, staticRenderFns } from "./DeleteImageModal.vue?vue&type=template&id=ca548674&"
import script from "./DeleteImageModal.vue?vue&type=script&lang=js&"
export * from "./DeleteImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ca548674')) {
      api.createRecord('ca548674', component.options)
    } else {
      api.reload('ca548674', component.options)
    }
    module.hot.accept("./DeleteImageModal.vue?vue&type=template&id=ca548674&", function () {
      api.rerender('ca548674', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Modals/DeleteImageModal.vue"
export default component.exports